<template>
    <div class="app" v-if="bShowMap">
        <div id="container" class="case-map">
            <div class="city-wrap" @click="openCityPicker">{{sCity}}</div>
            <div class="search-wrap">
                <input placeholder="请输入小区地址" v-model="sValue" @input="search"/>
                <ul v-if="arrTips.length">
                    <li v-for="(item,index) in arrTips" @click="select(item)" :key="index">
                        <h2>{{item.name||""}}</h2>
                        <p>{{item.district}}{{item.address}}</p>
                    </li>
                </ul>
            </div>
            <div class="clear" @click="sValue = ''">清除</div>
            <div class="location"></div>
            <div class="confirm" @click="confirm" v-show="oAdd.location">确认</div>
        </div>
        <!-- 地址选择 -->
        <awesome-picker ref="picker" :anchor="arrAnchor" :data="arrCity" :colorConfirm="oPicker.colorConfirm" @confirm="confirmCity"></awesome-picker>
    </div>
</template>

<script>
import MapLoader from "@/libs/AMap.js";
import oForm     from "@/js/form.js";
import { geoGetLocation } from "@/js/wx.js";
let oMap = null;
export default {
    props: {
        nLng: {
            type: Number,
            default: null
        },
        nLat: {
            type: Number,
            default: null
        },
        oAddress: {
            type: Object,
            default: {}
        },
        bShowMap: {
            type: Boolean,
            default: false
        },
        arrCity: {
            type: Array,
            default: []
        },
        inputText: {
            type: String,
            default: ""
        },
        selectText: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            sValue: "",
            arrTips: [],
            arrAnchor: [
                { index: 8, value: "上海市" },
                { index: 0, value: "上海市" }
            ],
            oAdd: {},
            oPicker: {
                colorConfirm: "rgba(33, 51, 102, 1)"
            },
            sCity: "",
            sProvince:"",
            bFlag:true
        };
    },
    watch: {
        bShowMap(val) {
            if (val) {
                this.$nextTick(() => {
                    this.sCity = this.selectText
                    this.sValue = this.inputText
                    this.initMap();
                });
            }
        }
    },
    methods: {
        // 打开城市选择
        openCityPicker() {
            this.$refs.picker.show();
        },
        // 选择城市
        confirmCity(res) {
            let that = this
            that.bFlag = false
            that.sCity = res[1].value;


            geoGetLocation(res[0].value + res[1].value)
                .then((result) => {
                    // console.log(result.geocodes[0].location);
                    
                    that.sValue = res[0].value + res[1].value;

                    this.oAdd = {
                        formattedAddress: that.sValue,
                        name: that.sValue,
                        location: result.geocodes[0].location
                    };
                    
                    that.setCenter(result.geocodes[0].location.lng, result.geocodes[0].location.lat);
                })
                .catch((err) => {
                   // console.log(err);
                });

            this.$emit(
                "update:nCityId",
                this.arrCity[res[0].index].children[res[1].index].id
            );
        },
        // 确认选择
        confirm() {
            let oAdd = this.oAdd;
            this.$emit("update:nLng", oAdd.location.lng);
            this.$emit("update:nLat", oAdd.location.lat);
            this.$emit("update:oAddress", oAdd);
            this.$emit("update:bShowMap", false);
          //  console.log('------32323',oAdd)
            // console.log(1111)
        },
        // 选择地址
        select(item) {
         //   console.log(">>>>>", item)
            this.bFlag = false
            this.sValue = item.name;
            this.oAdd = {
                formattedAddress: `${item.district}${item.address}`,
                name: item.name,
                location: item.location
            };
            this.arrTips = [];
            this.setCenter(item.location.lng, item.location.lat);
        },
        initMap() {
            const that = this;
            MapLoader().then(
                AMap => {
                    // console.log("地图加载成功",AMap);
                    oMap = new AMap.Map("container", {
                        center: [this.nLng, this.nLat],
                        zoom: 15,
                        showIndoorMap: false, // 是否在有矢量底图的时候自动展示室内地图，PC默认true,移动端默认false
                        resizeEnable: true, //是否监控地图容器尺寸变化，默认值为false
                        dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
                        keyboardEnable: false, //地图是否可通过键盘控制，默认为true
                        doubleClickZoom: false, // 地图是否可通过双击鼠标放大地图，默认为true
                        zoomEnable: true, //地图是否可缩放，默认值为true
                        rotateEnable: false // 地图是否可旋转，3D视图默认为true，2D视图默认false
                    });
                    // console.log("----222", oMap);
                    that.logMapinfo();
                    oMap.on("touchend", that.getCenter);
                },
                e => {
                   // console.log("地图加载失败", e);
                }
            );
        },
        logMapinfo() {
            let that = this;
            // if (!this.sCity) {
                oMap.getCity((res) =>{
                  //  console.log('当前城市',res)
                    that.sCity = res.city || res.province;
                    that.sProvince = res.province;
                    that.getCityId()
                });
            // }
        },
        getCenter() {
            // if (this.bFlag) {
                var oCenter = oMap.getCenter();
                this.getAddress(oCenter.lng, oCenter.lat);
            // }
        },
        setCenter(lng, lat) {
            let position = [lng, lat];
            oMap.setCenter(position);
        },
        search() {
            let that = this;
            AMap.plugin("AMap.Autocomplete", function() {
                var autoOptions = {
                    city: that.sCity,
                    datatype: "all"
                };
                var autoComplete = new AMap.Autocomplete(autoOptions);
                autoComplete.search(that.sValue, function(status, result) {
                    // 搜索成功时，result即是对应的匹配数据
                    // console.log(result);
                    if (result.tips) {
                        that.arrTips = result.tips.filter(item => item.location);
                      //  console.log("列表>>>", result.tips)
                    } else {
                        that.arrTips = [];
                    }
                });
            });
        },
        getAddress(nLng, nLat) {
            let that = this;
            AMap.plugin("AMap.Geocoder", function() {
                var geocoder = new AMap.Geocoder({
                    city: that.sCity,
                    extensions: "all"
                });

                var lnglat = [nLng, nLat];

                geocoder.getAddress(lnglat, function(status, result) {
                  //  console.log(result);
                    if (status === "complete" && result.info === "OK") {
                        // result为对应的地理位置详细信息
                     //   console.log('-----',result);
                        if (result.regeocode.aois.length) {
                            // console.log("aois>>>", result.regeocode.aois)
                            that.sValue = result.regeocode.aois[0].name;
                            that.oAdd = {
                                formattedAddress:
                                    result.regeocode.formattedAddress,
                                name: result.regeocode.aois[0].name,
                                location: result.regeocode.aois[0].location
                            };
                        } else if (result.regeocode.pois.length) {
                            // console.log("pois>>>", result.regeocode.pois)
                            that.sValue = result.regeocode.pois[0].name;
                            that.oAdd = {
                                formattedAddress:
                                    result.regeocode.formattedAddress,
                                name: result.regeocode.pois[0].name,
                                location: result.regeocode.pois[0].location
                            };
                        } else {
                              Toast({
                                    message: "未找到该地址",
                                    position: "center",
                                    duration: 1200,
                              });
                        }
                        that.arrTips = [];
                        that.bFlag = true
                    }
                });
            });
        },
       // 城市名转id
        getCityId() {
            oForm
                .getCityId({ city: this.sCity })
                .then(res => {
                     this.$emit(
                        "update:nCityId",
                        res.data.data.result.city_id
                    );
                });
        },
    }
};
</script>

<style lang="scss" scoped>
.case-map {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    .location {
        width: 64px;
        height: 64px;
        position: fixed;
        z-index: 999;
        left: 50%;
        top: 50%;
        margin-left: -32px;
        margin-top: -64px;
        // top: 0;
        // bottom: 0;
        // margin: auto;
        background: url(~@/assets/images/icon-location.png) no-repeat
            center/100% 100%;
    }
    .city-wrap {
        width: 180px;
        height: 108px;
        box-shadow: 0px 0px 30px 0px rgba(168, 183, 251, 0.4);
        border-radius: 20px;
        border: solid 1px rgba(190, 201, 249, 1);
        position: fixed;
        left: 10px;
        top: 30px;
        background-color: #ffffff;
        z-index: 1000;
        font-size: 30px;
        text-align: center;
        line-height: 108px;
    }
    .clear{
        width: 180px;
        height: 108px;
        box-shadow: 0px 0px 30px 0px rgba(168, 183, 251, 0.4);
        border-radius: 20px;
        border: solid 1px rgba(190, 201, 249, 1);
        position: fixed;
        right: 15px;
        top: 30px;
        background-color: #ffffff;
        z-index: 1000;
        font-size: 30px;
        text-align: center;
        line-height: 108px;
    }
    .search-wrap {
        width: 345px;
        height: 108px;
        box-shadow: 0px 0px 30px 0px rgba(168, 183, 251, 0.4);
        border-radius: 20px;
        border: solid 1px rgba(190, 201, 249, 1);
        position: fixed;
        right: 205px;
        top: 30px;
        background-color: #ffffff;
        z-index: 1000;
        padding: 30px;
        font-size: 30px;
        color: rgba(45, 45, 45, 1);
        display: flex;
        align-items: center;
        input {
            font-size: 30px;
            height: 90px;
            line-height: 90px;
            width: 100%;
        }
        ul {
            width: 100%;
            box-shadow: 0px 0px 30px 0px rgba(168, 183, 251, 0.4);
            border-radius: 20px;
            border: solid 1px rgba(190, 201, 249, 1);
            position: absolute;
            left: 0;
            top: 118px;
            overflow-y: scroll;
            max-height: 600px;
            z-index: 1001;
            background-color: #ffffff;
            li {
                // height: 80px;
                color: #333333;
                padding: 20px 30px;
                background-color: #ffffff;
                border-bottom: 1px solid rgba(181, 181, 181, 0.3);
                h2 {
                    font-size: 30px;
                    font-weight: normal;
                    line-height: 50px;
                }
                p {
                    font-size: 24px;
                    color: rgba(67, 67, 67, 0.8);
                    line-height: 30px;
                }
            }
        }
    }
    .confirm {
        width: 290px;
        height: 80px;
        background-color: #2f7fed;
        border-radius: 40px;
        color: rgba(255, 255, 255, 1);
        font-size: 30px;
        text-align: center;
        line-height: 80px;
        position: fixed;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 100px;
        z-index: 999;
    }
}
</style>
